/**
 * Created by Thomas Mark
 * Date: 2020-12-30
 * 
 * Benutzer anmelden
 * 
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { Icon } from '../../partials/Icons';
import Logo from "../../partials/Logo";
import Header from "../../partials/Header";
import Footer from "../../partials/Footer";
import Welcome from "../../partials/Welcome";
import Dialog from '@material-ui/core/Dialog';

import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";
import * as appActions from "../../../store/actions/appActions";
import * as userActions from '../../../store/actions/userActions';
import * as versionActions from '../../../store/actions/versionActions';
import * as portfolioActions from '../../../store/actions/portfolioActions';

class LoginModal extends Component {

    constructor(props) {
        super(props)

        this.component = 'LoginModal';

        this.debug = false

        this.state = {
            email: '',
            password: ''
        }
    }

    /**
     * Preset Credentials
     * to be able to preset the credentials with the previous login-Data, we read the 
     * 'login.json' from IndexedDB. Credentials will be preset only it 'login.json' exists.
     */
    loadLoginData = async () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:loadLoginData()`);
        debug && console.log(`##################################################\n\n`);

        debug && console.log('login.json laden');

        await cordova.readLocalJSON(null, 'login.json').then((loginJSON) => {
            debug && console.log('   readLocalJSON(login.json) success:', loginJSON);
            this.setState(loginJSON);
        }).catch(async (error) => {
            debug && console.log('   readLocalJSON(login.json) error:', error);
        });
    }


    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidMount = async () => {
        const debug = false;

        debug && console.log(`\n\n##################################################`);
        debug && console.log(`${this.component}:Mount`);
        debug && console.log(`##################################################\n\n`);

        await this.loadLoginData();
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================

    render() {
        const { modalDialog, windowWidth, windowHeight, toolbarHeight, headerHeight, unitHeight } = this.props.app;
        const { user } = this.props;

        const styleText = utils.getStyleHeight(unitHeight, 1.0, 1.0, .25)
        const styleButton = { backgroundColor: 'rgb(145,28,33)' }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderForm = () => {

            const onChange = (e) => {
                this.setState({
                    [e.target.id]: e.target.value
                })
            }

            const onSubmit = (e) => {
                e.preventDefault();

                const debug = false;

                /**
                 * #userData #vhost
                 * In der iPad-Version wird der virtuelle Host aus der Login 
                 * E-Mail-Adresse abgeleitet. Mit Hilfe des virtuellen Host aus 
                 * der E-Mail-Adresse wird die URL für den allgemeinen Zugriff 
                 * auf das API zusammengestellt. Die URL wir in der globalen 
                 * Variablen 'apiURL' gespeichert.
                 */
                if (window['cordova']) {
                    debug && console.log('email:', this.state.email);
                    const vhost = utils.getVirtualHostFromEMail(this.state.email);

                    if (vhost) {
                        debug && console.log('vhost:', vhost);
                        const apiURLnew = `https://${vhost}.forsale-s.de`;
                        debug && console.log('apiURLnew:', apiURLnew);

                        // neue apiURL direkt im REDUX-Store speichern
                        this.props.setApiURL(apiURLnew);
                    }
                }

                // =============================================================================            
                // Login durchführen
                // =============================================================================            
                this.props.loginUser(this.state, (data) => {
                    /**
                     * #saveLoginData
                     * save credentials in 'login.json', for next Login 
                     */
                    cordova.writeLocalJSON(null, 'login.json', this.state)
                        .then((data) => {
                            debug && console.log('   writeLocalJSON(login.json) success:', data);
                        })
                        .catch((error) => {
                            console.log('   writeLocalJSON(login.json) error:', error);
                        });
                }, (error) => {
                    console.log(`can't write credentials! error: `, error)
                }); // userAction.js
            }

            const renderButton = () => {

                if (user.type.indexOf('PENDING') !== -1) {
                    return (
                        <button className="inline-flex items-center focus:outline-none mr-4 px-16 py-2 rounded" style={styleButton} disabled>
                            <Icon color='white' type='settings' width={unitHeight * .25} height={unitHeight * .25} className="animate-spin mr-3" />
                            Processing
                        </button>
                    )
                }

                return (
                    <button className="inline-flex items-center focus:outline-none mr-4 px-16 py-2 rounded" style={styleButton}>Login</button>
                )
            }

            return (
                <form onSubmit={onSubmit}>
                    <div className="mx-auto container max-w-2xl md:w-3/4 bg-gray-200">
                        <div className="space-y">
                            <div className="md:inline-flex space-y-4 md:space-y-0 w-full p-4 text-gray-600 items-center">
                                <div className="md:w-full mx-auto max-w-sm space-y-2" >
                                    <h1>Anmelden</h1>
                                    <div className="w-full inline-flex border" style={styleText}>
                                        <div className="w-4/12 px-2 bg-gray-100">E-Mail</div>
                                        <input className="w-8/12 focus:outline-none px-2" type="email" id='email' onChange={onChange} value={this.state.email} />
                                    </div>
                                    <div className="w-full inline-flex border" style={styleText}>
                                        <div className="w-4/12 px-2 bg-gray-100">Passwort</div>
                                        <input autoComplete="on" className="w-8/12 focus:outline-none px-2" type="password" id='password' onChange={onChange} value={this.state.password} />
                                    </div>
                                </div>
                            </div>

                            <div className="w-full flex justify-center text-white" >
                                {renderButton()}
                            </div>

                            <div className="w-full pt-2 text-center text-black font-bold">
                                <button className="inline-flex items-center focus:outline-none mr-4">
                                    {user['error'] && user.error !== null ? user.error.data.message : <br />}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        const height = windowHeight - toolbarHeight - headerHeight;

        const style = {
            height: height + 'px',
            minHeight: height + 'px',
            backgroundColor: 'rgb(145,28,33)'
        }

        return (
            <Dialog open={true} fullScreen>
                <Header />
                <div className="w-full p-8" style={style}>
                    <div className="relative w-full h-full flex flex-col">
                        {renderForm()}
                        <Logo width={windowWidth} version={false} />
                        <div className="absolute bottom-0 w-full">
                            <Welcome width={windowWidth} />
                        </div>
                    </div>
                </div>
                <Footer />
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        user: state.user,
        version: state.version,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, userActions, versionActions, portfolioActions), dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal)
